var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16H3C2.60218 16 2.22064 15.842 1.93934 15.5607C1.65804 15.2794 1.5 14.8978 1.5 14.5V9.25C1.5 8.85218 1.65804 8.47064 1.93934 8.18934C2.22064 7.90804 2.60218 7.75 3 7.75H5.25M10.5 6.25V3.25C10.5 2.65326 10.2629 2.08097 9.84099 1.65901C9.41903 1.23705 8.84674 1 8.25 1L5.25 7.75V16H13.71C14.0717 16.0041 14.4228 15.8773 14.6984 15.643C14.9741 15.4087 15.1558 15.0827 15.21 14.725L16.245 7.975C16.2776 7.76002 16.2631 7.54051 16.2025 7.33169C16.1419 7.12287 16.0366 6.92972 15.8939 6.76564C15.7512 6.60155 15.5746 6.47045 15.3762 6.38141C15.1778 6.29238 14.9624 6.24754 14.745 6.25H10.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbsUpIcon.f4912fe91f085dc228a5373789507176.svg";
export { ForwardRef as ReactComponent };